let scrollPosition = 0;
export function getCssVar(varName) {
    return getComputedStyle(document.documentElement)
        .getPropertyValue(varName);
}

export function setCssVar(varName, value) {
    let root = document.documentElement;
    root.style.setProperty(varName, value);
}

export function onOpenModal() {
    scrollPosition = window.pageYOffset;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.width = '100%';
}

export function onCloseModal() {
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');
    document.body.style.removeProperty('width');
    window.scrollTo(0, scrollPosition);
}